module.exports = __webpack_public_path__ + "img/haiti.96e33c78.svg";